module.exports = __webpack_public_path__ + "img/code.c477f417.jpg";